import React from 'react';
import Xmas from './Xmas.jsx';
import Closed from './Closed.jsx';
import SomeTimes from '../../utils/SomeTimes.jsx';

export const Switcher = () => <>
  <SomeTimes from="2025-11-17 09:00:00" to="2025-12-19 13:59:59">
    <Xmas/>
  </SomeTimes>
  <SomeTimes from="2025-12-19 14:00:00" to="2026-01-05 09:00:00">
    <Closed/>
  </SomeTimes>
</>


export default Switcher